<template>
  <div class="encoding-container uk-width-1-1" :id="id">
    <div class="encoding-background uk-ratio uk-ratio-16-9" :class="{ complete: encodingComplete }" :style="{ 'background-image': 'url(' + thumbnail + ')' }">
      <div class="uk-position-center uk-text-center">
        <span class="encoding-status" v-show="percentage < 100 && !encodingComplete">
				</span>
      </div>
    </div>
		<div class="uk-margin-top">
			<span v-show="!encodingComplete">Video wordt omgezet, refresh de pagina zodra hij klaar is. Progressie: {{ percentage }}%</span>
      <span v-show="encodingComplete"><i class="fas fa-check fa-4x color-green"></i><br>Encoding done, refresh the page to show the encoded results (gif or video).</span>
      <span v-show="encodingError !== ''" class="color-red">{{ encodingError }}</span>
		</div>
    <progress v-show="!encodingComplete" class="encoding-progress-bar uk-progress" :value="percentage" max="100"></progress>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    id: String,
    progressUrl: String,
    thumbnail: String
  },
  data() {
    return {
      percentage: 0,
      timer: null,
      encodingComplete: false,
      encodingError: '',
      previousPercentage: null,  // to keep track of the previous progress value
      stagnantProgressCount: 0,      
    }
  },
  mounted() {
    this.init();
    
    console.log(this.thumbnail)
  },
  methods: {
    init() {

			var component = this;
      component.$logger('app/components/transcoder-progress/init');

      component.timer = setInterval(() => {
        component.checkProgress();
      }, 1000);
    },
checkProgress() {
      const component = this;
      const id = component.id;
      const progressUrl = component.progressUrl;
    
      if (!progressUrl || !id) {
        return;
      }
    
      component.$logger('app/components/transcoder-progress/checkProgress/url: ' + progressUrl);
    
      axios.get(progressUrl)
        .then(response => {
          const data = response.data;
          console.log(data);
    
          if (data.success === false) {
            component.$logger('app/components/transcoder-progress/checkProgress/error/' + id);
            clearInterval(component.timer);
            component.encodingError = data.message;
          } else {
            if (data.progress) {
              component.$logger('app/components/transcoder-progress/checkProgress/update-progress/' + id + '/' + data.progress);
              component.percentage = data.progress;
    
              if (component.percentage === component.previousPercentage) {
                component.stagnantProgressCount++;
                if (component.stagnantProgressCount >= 5) {
                  component.encodingComplete = true;
                  clearInterval(component.timer);
                }
              } else {
                component.stagnantProgressCount = 0;  // Reset the counter if progress changes
              }
    
              component.previousPercentage = component.percentage;  // Update the previous progress value
            } else {
              component.$logger('app/components/transcoder-progress/checkProgress/stop-progress/' + id);
              component.encodingComplete = true;
              clearInterval(component.timer);
            }
          }
        })
        .catch(error => {
          console.log(error);
          component.$logger('app/components/transcoder-progress/checkProgress/error/' + id, 'error');
          clearInterval(component.timer);
          component.encodingError = error;
        });
    }
  }
}
</script>
